import { render, staticRenderFns } from "./sub-lease.vue?vue&type=template&id=3c765d4e&"
import script from "./sub-lease.vue?vue&type=script&lang=js&"
export * from "./sub-lease.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports